// Core
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

// Components

export type LayoutDefaultElement = HTMLDivElement;

export type LayoutDefaultProps = {
  title: string;
  className?: string;
};

export const LayoutDefault = React.forwardRef<
  LayoutDefaultElement,
  React.PropsWithChildren<LayoutDefaultProps>
>(({ children, className }, ref) => {
  const theme = useTheme();

  // const contentHeight = `calc(${theme.customLayoutHeight.rootHeight} - ${theme.customLayoutHeight.appNavBarHeight})`;

  return (
    <div
      ref={ref}
      className={className}
      style={{
        height: theme.customLayoutHeight.rootHeight
      }}
    >
      <Box
        id="main-content-container"
        sx={{
          height: {
            xs: "calc(100vh - max(env(safe-area-inset-top, 0px), 20px))",
            sm: "100vh"
          },
          paddingTop: {
            xs: "max(env(safe-area-inset-top, 0px), 20px)",
            sm: 0
          },
          overflow: "auto",
          backgroundColor: "transparent",
          position: "relative",
          // Add white background for the safe area padding on mobile
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: {
              xs: "max(env(safe-area-inset-top, 0px), 20px)",
              sm: 0
            },
            backgroundColor: (theme) => theme.palette.background.paper,
            zIndex: 0
          },
          "& > *": {
            position: "relative",
            zIndex: 1
          }
        }}
      >
        {children}
      </Box>
    </div>
  );
});

export default LayoutDefault;
